import { TabBar } from 'antd-mobile';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    AppOutline,
    CalculatorOutline,
    PayCircleOutline,
    UserOutline,
} from 'antd-mobile-icons';
import { Image as ImageIcon } from 'lucide-react';
import { useStore } from '../store';
import './BottomNav.css';

const allTabs = [
    { key: '/', title: 'หน้าแรก', icon: <AppOutline />, ownerOnly: false },
    { key: '/calculator', title: 'คิดเงิน', icon: <CalculatorOutline />, ownerOnly: false },
    { key: '/qr', title: 'QR', icon: <PayCircleOutline />, ownerOnly: false },
    { key: '/summary', title: 'สลิป', icon: <ImageIcon size={22} />, ownerOnly: false },
    { key: '/profile', title: 'โปรไฟล์', icon: <UserOutline />, ownerOnly: true },
];

export function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const dbUser = useStore((s) => s.dbUser);

    // Staff cannot see Profile tab
    const isStaff = dbUser?.role === 'STAFF';
    const tabs = isStaff ? allTabs.filter(t => !t.ownerOnly) : allTabs;

    return (
        <div className="bottom-nav-wrapper">
            <TabBar
                activeKey={location.pathname}
                onChange={(key) => navigate(key)}
                safeArea
            >
                {tabs.map((tab) => (
                    <TabBar.Item
                        key={tab.key}
                        icon={tab.icon}
                        title={tab.title}
                    />
                ))}
            </TabBar>
        </div>
    );
}

export default BottomNav;
